export default __webpack_public_path__ + "static/dog-75098a5f3a2aea7ac495a1a1328b4efb.gif";